import { ReviewComponent } from "projects/reg-hub-client/src/app/orders/review/review.component";
import { Step, StepValidationState } from "../../../../../interfaces/step";
import { Stepper } from "../../../../../interfaces/stepper";
import { RenewalComponent } from "projects/reg-hub-client/src/app/orders/renewal/renewal.component";

export class ReregistrationStepper implements Stepper {

    steps: Step[];

    constructor() {
        this.steps = [
            { title: "Details", content: RenewalComponent, validationState: StepValidationState.DefaultState },
            { title: "Review", content: ReviewComponent, validationState: StepValidationState.DefaultState }
        ]
    }
}